import { defineStore } from "pinia";

import { fetchEpgItems, addEpgItem, deleteEpgItem } from "Lib/epg";

export default defineStore('epg', {
  namespaced: true,
  state: {
    epg_items: null,
  },
  actions: {
    async fetchEpgItems() {
      const items = await fetchEpgItems();
      if (items) {
        this.epg_items = items;
      }
    },
    async addEpgItem(name) {
      const item = await addEpgItem(name);
      if (item) {
        this.epg_items.unshift(item);
      }
    },
    async deleteEpgItem(uuid) {
      const { success } = await deleteEpgItem(uuid);
      if (success === true) {
        this.epg_items = this.epg_items.filter(obj => obj.uuid !== uuid);
      }
    },
  },
});
